import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import TransitionScreen from "@/pages/finance-eligibility/components/TransitionScreen";
import { Form } from "@/common/HOCs/rhf/form-provider/FormProvider";
import { useDynamicForm } from "@/pages/finance-eligibility/context/ScreenContext";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from 'react-hook-form';
import ScreenButton from "@/pages/finance-eligibility/components/ScreenButton";
import { toast } from "sonner";
import { useTranslation } from "@i18n";
import { useMemo } from "react";
import { AuthPopupHOC } from "@/_MiniApps/auth/AuthContext";
import banners from "@data/banners/login-pages/saved_search.json";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useCMS } from "@hooks/useCMS";
import useHelpers from "@hooks/useHelpers";
import { api__checkFinanceEligibility } from "@/apis/finance-eligibility/api__checkFinanceEligibility";
//@ts-ignore

import { useLocation } from "react-router-dom";
import { trackEvents } from "@/common/events/events";
import useSubmissionSource from "@hooks/useSubmissionSource";
import useBoolean from "@hooks/useBoolean";
import stl from "@componentsShared/buts/SubmitButton/SubmitButton.module.css";
var StepperContent = function StepperContent() {
  var _useDynamicForm = useDynamicForm(),
    currentStep = _useDynamicForm.currentStep,
    schema = _useDynamicForm.schema,
    goToStep = _useDynamicForm.goToStep,
    state = _useDynamicForm.state,
    isQualified = _useDynamicForm.isQualified;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var lang = useLang();
  var _useCMS = useCMS(),
    imageUrl = _useCMS.imageUrl;
  var _useLocation = useLocation(),
    search = _useLocation.search;
  var searchParams = new URLSearchParams(search);
  var _useSubmissionSource = useSubmissionSource(),
    setSubmissionSource = _useSubmissionSource.setSubmissionSource;
  var condition_id = new URLSearchParams(search).get("condition_id");
  var submitting = useBoolean(false);
  var methods = useForm({
    mode: "all",
    resolver: zodResolver(schema)
  });
  var handleSubmit = methods.handleSubmit,
    trigger = methods.trigger,
    watch = methods.watch,
    isValid = methods.formState.isValid;
  var values = watch();
  var onSubmit = handleSubmit(function (data) {
    submitting.setTrue();
    console.log(isQualified(), 'isQualified');
    if (!isQualified()) {
      trackEvents("eligibility_check_complete", {
        is_eligible: "no"
      });
      submitting.setFalse();
      navigateTo("/site/finance-eligibility/disqualified");
    } else {
      try {
        api__checkFinanceEligibility({
          salary: (data === null || data === void 0 ? void 0 : data.salary) || (values === null || values === void 0 ? void 0 : values.salary),
          deduction: (data === null || data === void 0 ? void 0 : data.deduction) || (values === null || values === void 0 ? void 0 : values.deduction) || 0,
          condition: condition_id ? parseInt(condition_id) : data === null || data === void 0 ? void 0 : data.condition
        }).then(function (res) {
          if (!(res !== null && res !== void 0 && res.eligible)) {
            trackEvents("eligibility_check_complete", {
              is_eligible: "no"
            });
            navigateTo("/site/finance-eligibility/disqualified");
          } else {
            sessionStorage.setItem("eligibility_data", JSON.stringify(res));
            sessionStorage.setItem("finance_apply_data", JSON.stringify({
              salary: data === null || data === void 0 ? void 0 : data.salary,
              deduction: (data === null || data === void 0 ? void 0 : data.deduction) || 0,
              condition: condition_id ? parseInt(condition_id) : data === null || data === void 0 ? void 0 : data.condition
            }));
            var urlParams = new URLSearchParams();
            if (searchParams.get("post_id")) {
              urlParams.append("post_id", searchParams.get("post_id"));
            }
            if (searchParams.get("condition_id")) {
              urlParams.append("condition_id", searchParams.get("condition_id"));
            }
            var url = "/site/finance-eligibility".concat(urlParams.toString() ? "?".concat(urlParams.toString()) : '');
            trackEvents("eligibility_check_complete", {
              is_eligible: "yes"
            });
            setSubmissionSource("eligibility");
            submitting.setFalse();
            navigateToHard(url);
          }
        });
      } catch (e) {
        console.log(e.message);
      }
    }
  });
  var authScreenDesign = useMemo(function () {
    return {
      banners: {
        desktop: imageUrl(banners[lang].desktop_images[0]),
        mobile: imageUrl(banners[lang].mobile_images[0])
      },
      title: t("log_create_account", {
        ns: "web_common"
      }),
      description: t("log_create_account_check_re", {
        ns: "web_common"
      })
    };
  }, []);
  var handleScreenNextButton = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(checkAuth) {
      var isValid, selectedValue, selectedOption;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return trigger(currentStep.field_name, {
              shouldFocus: true
            });
          case 1:
            isValid = _context.v;
            if (isValid) {
              _context.n = 2;
              break;
            }
            toast.warning(t("verify_accuracy_information", {
              ns: "web_common"
            }), {
              position: "top-center",
              duration: 5000
            });
            return _context.a(2);
          case 2:
            if (!(currentStep.options && currentStep.options.length > 0)) {
              _context.n = 3;
              break;
            }
            // Get the user's selected value for this field.
            selectedValue = values[currentStep.field_name];
            selectedOption = currentStep.options.find(function (option) {
              return option.value === selectedValue;
            });
            if (!selectedOption) {
              _context.n = 3;
              break;
            }
            if (selectedOption.next_id !== null) {
              // For example: if user selected "true" (has next_id: 6), go to next screen.
              goToStep(selectedOption.next_id);
            } else {
              // If selected option's next_id is null (e.g. "false"), then trigger form submit.
              checkAuth(function (userData, isPendingActionCall) {
                isPendingActionCall && trackEvents("element_click", {
                  element_name: "eligibility",
                  user_login_status: "true"
                });
                if (userData) {
                  handleSubmit(onSubmit)();
                }
              });
            }
            return _context.a(2);
          case 3:
            // Fallback logic: if there are no options, then check the current step's next_id.
            if (currentStep.next_id !== null) {
              goToStep(currentStep.next_id);
            } else {
              checkAuth(function (userData, isPendingActionCall) {
                isPendingActionCall && trackEvents("element_click", {
                  element_name: "eligibility",
                  user_login_status: "true"
                });
                if (userData) {
                  handleSubmit(onSubmit)();
                }
              });
            }
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleScreenNextButton(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  if (!currentStep) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form, {
    methods: methods
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative",
    style: {
      height: "".concat(window.innerHeight, "px")
    }
  }, /*#__PURE__*/React.createElement(TransitionScreen, {
    screenData: currentStep,
    handleScreenNextButton: handleScreenNextButton,
    isFormValid: isValid,
    isSubmitting: submitting.value
  }), (currentStep === null || currentStep === void 0 ? void 0 : currentStep.next_text) && /*#__PURE__*/React.createElement("div", {
    className: "absolute bottom-0 w-full p-3 lg:hidden"
  }, /*#__PURE__*/React.createElement(AuthPopupHOC, {
    customModalClassName: "modalHideHeader",
    authScreenDesign: authScreenDesign,
    renderFunc: function renderFunc(checkAuth) {
      return /*#__PURE__*/React.createElement(ScreenButton, {
        onClick: function onClick() {
          return handleScreenNextButton(checkAuth);
        },
        disabled: !isValid,
        className: submitting.value ? "pointer-events-none" : ""
      }, submitting.value ? /*#__PURE__*/React.createElement("span", {
        className: stl.loader
      }) : currentStep.next_text);
    },
    onCancel: function onCancel() {
      trackEvents("element_click", {
        element_name: "eligibility",
        user_login_status: "false"
      });
    }
  })))));
};
export default StepperContent;